@if (toastService.message()) {
  <div class="pointer-events-none fixed right-4 top-4 z-[9999] w-[calc(100%-2rem)] max-w-sm">
    <div class="pointer-events-auto flex items-start justify-between gap-3 rounded-lg border px-4 py-3 shadow-lg" [class.border-green-200]="toastService.type() === 'success'" [class.bg-green-50]="toastService.type() === 'success'" [class.text-green-700]="toastService.type() === 'success'" [class.border-red-200]="toastService.type() === 'error'" [class.bg-red-50]="toastService.type() === 'error'" [class.text-red-700]="toastService.type() === 'error'" [class.border-blue-200]="toastService.type() === 'info'" [class.bg-blue-50]="toastService.type() === 'info'" [class.text-blue-700]="toastService.type() === 'info'">

      <p class="min-w-0 flex-1 text-sm font-medium">
        {{ toastService.message() }}
      </p>

      <button type="button" class="shrink-0 text-lg leading-none opacity-60 transition hover:opacity-100" (click)="toastService.close()" aria-label="Close notification">
        ×
      </button>

    </div>
  </div>
}